import { render, staticRenderFns } from "./AiAssistantModal.vue?vue&type=template&id=020865fa&scoped=true"
import script from "./AiAssistantModal.vue?vue&type=script&lang=js"
export * from "./AiAssistantModal.vue?vue&type=script&lang=js"
import style0 from "./AiAssistantModal.vue?vue&type=style&index=0&id=020865fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020865fa",
  null
  
)

export default component.exports